import { render } from "./errorPage2.vue?vue&type=template&id=62255538&scoped=true"
const script = {}

import "./errorPage2.vue?vue&type=style&index=0&id=62255538&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62255538"]])

export default __exports__